module.exports = __webpack_public_path__ + "static/media/Vatican.c89c37a3.png";